<div class="modal-header">
    <h3 class="modal-title">Update Vendor</h3>
</div>
<div class="modal-body">
    <ng-select [items]="items" [(ngModel)]="selectedItem" (search)="search($event)" [searchFn]="utilityService.noFilter" [bindLabel]="bindLabel"/>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="clearSearchField()">{{ clearButtonText }}</button>
    <button type="button" class="btn btn-primary" (click)="saveAndCloseModal()" [disabled]="selectedItem == null">{{ saveButtonText }}</button>
    <button type="button" class="btn btn-default" (click)="cancelAndCloseModal()">{{ cancelButtonText }}</button>
</div>